export {
  GlobalStylesProvider,
  PLATFORM_COOKIE,
  REBRAND_COOKIE,
  useTheme,
} from './GlobalStylesProvider';
